// print year
let footerYear = new Date().getFullYear();
document.querySelector('[rel="js-footer__year"]').innerHTML = footerYear;